import { render, staticRenderFns } from "./AssetDefinitions.vue?vue&type=template&id=663135d4&"
import script from "./AssetDefinitions.vue?vue&type=script&lang=js&"
export * from "./AssetDefinitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports